import { useCallback } from "react"
import { graphql, useMutation } from "react-relay"
import { UpdateAppointmentUrgencyInput } from "@/modules/waiting-room/services/__generated__/useUpdateAppointmentUrgencyMutation.graphql"

const mutation = graphql`
  mutation useUpdateAppointmentUrgencyMutation($input: UpdateAppointmentUrgencyInput!) {
    updateAppointmentUrgency(input: $input) {
      appointment {
        urgency
        flexibility
        reviewStatus
      }
    }
  }
`

export function useUpdateAppointmentUrgencyMutation() {
  const [commit] = useMutation(mutation)

  return useCallback(
    (input: UpdateAppointmentUrgencyInput, handleComplete?: () => void) => {
      commit({
        variables: { input },
        onCompleted: handleComplete,
      })
    },
    [commit],
  )
}
